module.exports = __webpack_public_path__ + "assets/fonts/roboto-regular.woff";